import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import classnames from 'classnames';

import {
  SR_API_ACTION_HOUSEHOLD_ADD_NOTE,
  SR_API_ACTION_PARTNER_ADD_NOTE,
  SR_API_ACTION_RENTLINX_LEAD_ADD_NOTE,
  SR_API_ACTION_LISTING_NOTE_CREATE,
  SR_API_ACTION_JOB_ORDER_NOTE_CREATE,
} from 'api/actionTypes';

import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';
import SrFormikField, {
  SR_FIELD_THEME_ADOBE,
  SR_FIELD_THEME_GREYCLIFF_DARK_BG,
} from 'client/components/SrFormikField';

import postWithState from 'client/actions/postWithState';

export const SR_CREATE_NOTE_FORM_THEME_WHITNEY = 'createNoteFormThemeWhitney';
export const SR_CREATE_NOTE_FORM_THEME_GREYCLIFF = 'createNoteFormThemeGreycliff';
export const SR_CREATE_NOTE_FORM_THEME_ADOBE = 'createNoteFormThemeAdobe';

const SR_CREATE_NOTE_FORM_THEMES = [
  SR_CREATE_NOTE_FORM_THEME_WHITNEY,
  SR_CREATE_NOTE_FORM_THEME_GREYCLIFF,
  SR_CREATE_NOTE_FORM_THEME_ADOBE,
];

const initialValues = {
  note: '',
};

const getApiActionType = ({ householdId, partnerId, rentlinxLeadId, listingId, jobOrderId }) => {
  if (partnerId) {
    return SR_API_ACTION_PARTNER_ADD_NOTE;
  }
  if (rentlinxLeadId) {
    return SR_API_ACTION_RENTLINX_LEAD_ADD_NOTE;
  }
  if (householdId) {
    return SR_API_ACTION_HOUSEHOLD_ADD_NOTE;
  }
  if (listingId) {
    return SR_API_ACTION_LISTING_NOTE_CREATE;
  }
  if (jobOrderId) {
    return SR_API_ACTION_JOB_ORDER_NOTE_CREATE;
  }
};

class SrCreateNoteForm extends Component {
  static propTypes = {
    partnerId: PropTypes.number,
    householdId: PropTypes.number,
    rentlinxLeadId: PropTypes.number,
    listingId: PropTypes.number,
    jobOrderId: PropTypes.number,
    dispatch: PropTypes.func.isRequired,
    reloadDataTable: PropTypes.func.isRequired,
    theme: PropTypes.oneOf(SR_CREATE_NOTE_FORM_THEMES),
    onNoteCreated: PropTypes.func,
  };

  static defaultProps = {
    theme: SR_CREATE_NOTE_FORM_THEME_WHITNEY,
  };

  _getFormikFieldTheme = () => {
    const { theme } = this.props;
    switch (theme) {
      case SR_CREATE_NOTE_FORM_THEME_GREYCLIFF:
        return SR_FIELD_THEME_GREYCLIFF_DARK_BG;
      case SR_CREATE_NOTE_FORM_THEME_ADOBE:
        return SR_FIELD_THEME_ADOBE;
      default:
        return null;
    }
  };

  _onSubmit = ({ note }, { resetForm }) => {
    if (!note) return;
    const {
      dispatch,
      householdId,
      partnerId,
      listingId,
      jobOrderId,
      rentlinxLeadId,
      reloadDataTable,
    } = this.props;

    dispatch(postWithState, {
      action: getApiActionType({
        householdId,
        partnerId,
        rentlinxLeadId,
        listingId,
        jobOrderId,
      }),
      payload: {
        partnerId,
        householdId,
        rentlinxLeadId,
        listingId,
        jobOrderId,
        note,
      },
    }).then((note) => {
      reloadDataTable(note.id);
      resetForm({ ...initialValues });

      if (this.props.onNoteCreated) {
        this.props.onNoteCreated(note);
      }
    });
  };

  render() {
    const { theme } = this.props;
    const formikFieldTheme = this._getFormikFieldTheme();

    return (
      <div className={classnames('SrCreateNoteForm', theme)}>
        <Formik
          enableReinitialize
          initialValues={{ ...initialValues }}
          onSubmit={this._onSubmit}
          render={(formikBag) => (
            <Form>
              <SrFormikField
                theme={formikFieldTheme}
                formikBag={formikBag}
                formField={{
                  id: 'note',
                  validations: ['required'],
                  type: 'long_text',
                  properties: {
                    noMargin: true,
                    placeholder: 'Write note here...',
                    onKeyPress: (e) => {
                      if (e.which === 13) {
                        e.preventDefault();
                        formikBag.handleSubmit();
                      }
                    },
                  },
                }}
              />

              {theme === SR_CREATE_NOTE_FORM_THEME_WHITNEY && (
                <ButtonDeprecated theme={BUTTON_THEME_BLUE} type="submit">
                  add note
                </ButtonDeprecated>
              )}
            </Form>
          )}
        />
      </div>
    );
  }
}

SrCreateNoteForm.displayName = 'SrCreateNoteForm';

export default SrCreateNoteForm;
